import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    firstSection: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,

      '& .MuiTypography-h1': {
        margin: '2rem 0 1.5rem',
      },

      '& .MuiTypography-h4': {
        fontWeight: 500,
        color: theme.palette.text.secondary,
      },

      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        '& .MuiFormControl-root': {
          width: '100%',
          margin: '1rem 0',
        },
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',

      '& button': {
        height: 'auto',
        width: 'auto',
        minWidth: '10rem',
        padding: '1rem 1.5rem',
        margin: 0,
      },

      '& > button': {
        color: '#727970',
      },

      '& > div button:first-child': {
        color: theme.palette.primary.dark,
      },
    },
    autocomplete: {
      width: '100%',
      '& .MuiTextField-root': {
        width: 'inherit',
        margin: 0,
      },
      '& .MuiAutocomplete-inputRoot': {
        paddingRight: '1.4rem',
      },

      '& .MuiChip-root': {
        backgroundColor: 'transparent',
        border: '1px solid #CECFCE',

        height: 'max-content',

        '& .MuiChip-deleteIcon': {
          color: theme.palette.secondary.main,
          '& .MuiSvgIcon-root': {
            width: 18,
            height: 'min-content',
          },
        },
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',

      maxWidth: '30rem',
      fontSize: '1.2rem',
      padding: theme.spacing(1),

      border: 'none',
      borderRadius: 5,
    },
  }),
)
